import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Modal, Icon, infoIcon, ButtonSecondary, ButtonPrimary, ContentBlock, ContentItem, Circle} from '@ace-de/ui-components';
import * as invoiceSubmissionActionTypes from '../invoiceSubmissionActionTypes';

const CancelInvoiceSubmissionModal = props => {
    const {cx} = useStyles();
    const {hasBackdrop, confirmInvoiceSubmissionCancellation, declineInvoiceSubmissionCancellation} = props;
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('invoice_submission_cancel_modal');

    return (
        <Modal
            contentClassName={cx([
                'global!ace-u-flex',
                'global!ace-u-flex--justify-center',
                'global!ace-u-modal-content-size--xs',
            ])}
            hasBackdrop={hasBackdrop}
            closeFunction={declineInvoiceSubmissionCancellation}
        >
            <ContentBlock
                className={cx([
                    'global!ace-u-flex',
                    'global!ace-u-flex--direction-column',
                    'global!ace-u-flex--justify-center',
                ])}
            >
                <ContentItem
                    className={cx([
                        'global!ace-u-flex',
                        'global!ace-u-flex--align-center',
                        'global!ace-u-flex--direction-column',
                    ])}
                >
                    <Circle
                        className={cx([
                            'ace-c-circle--small',
                            'global!ace-u-margin--bottom-24',
                        ])}
                    >
                        <Icon
                            icon={infoIcon}
                            className={cx([
                                'ace-c-icon--m',
                                'ace-c-icon--color-highlight',
                            ])}
                        />
                    </Circle>
                    <h2
                        className={cx([
                            'global!ace-u-margin--bottom-16',
                            'global!ace-u-typography--variant-h2',
                            'global!ace-u-typography--align-center',
                        ])}
                    >
                        {translateModal('title.cancel_processing')}
                    </h2>
                    <p
                        className={cx([
                            'global!ace-u-margin--bottom-24',
                            'global!ace-u-typography--align-center',
                            'global!ace-u-typography--variant-body',
                        ])}
                    >
                        {translateModal('text.cancel_processing')}
                    </p>
                    <ButtonPrimary
                        name="cancelInvoiceSubmission"
                        className={cx([
                            'global!ace-u-width--full',
                            'global!ace-u-margin--small-bottom-16',
                        ])}
                        onClick={() => confirmInvoiceSubmissionCancellation()}
                    >
                        {translateModal('button_label.cancel')}
                    </ButtonPrimary>
                    <ButtonSecondary
                        name="declineCancelInvoiceSubmission"
                        className={cx('global!ace-u-width--full')}
                        onClick={declineInvoiceSubmissionCancellation}
                    >
                        {translateModal('button_label.back')}
                    </ButtonSecondary>
                </ContentItem>
            </ContentBlock>
        </Modal>
    );
};

CancelInvoiceSubmissionModal.propTypes = {
    hasBackdrop: PropTypes.bool,
    confirmInvoiceSubmissionCancellation: PropTypes.func.isRequired,
    declineInvoiceSubmissionCancellation: PropTypes.func.isRequired,
};

CancelInvoiceSubmissionModal.defaultProps = {
    hasBackdrop: true,
};

const mapDispatchToProps = dispatch => ({
    confirmInvoiceSubmissionCancellation: () => dispatch({
        type: invoiceSubmissionActionTypes.CONFIRM_CANCEL_INVOICE_SUBMISSION,
    }),
    declineInvoiceSubmissionCancellation: () => dispatch({
        type: invoiceSubmissionActionTypes.DECLINE_CANCEL_INVOICE_SUBMISSION,
    }),
});

export default connect(null, mapDispatchToProps)(CancelInvoiceSubmissionModal);
